import { createAxiosInstance } from '../utils/helpers'
import axios from 'axios'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'

import { displayMessages } from './common'

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA, payload: { path, value } });
	}
}

export function actualizarContrasena() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const currentpwd = getState().cambiarcontrasena.get('passwordactual')
        const newpwd = getState().cambiarcontrasena.get('passwordnuevo')
        const newpwdverification = getState().cambiarcontrasena.get('verificacion')

		axios.post(`${API_URL}/account/cambiar-contrasena`, {currentpwd, newpwd, newpwd_confirmation: newpwdverification})
		.then((res) => {
            dispatch({ type: types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA, payload: { path: 'passwordactual', value: '' } });
            dispatch({ type: types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA, payload: { path: 'passwordnuevo', value: '' } });
            dispatch({ type: types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA, payload: { path: 'verificacion', value: '' } });

            displayMessages(dispatch, { success: 'La contrasena ha sido actualizada exitosamente' })
		})
		.catch((err) => {
            dispatch({ type: types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA, payload: { path: 'passwordactual', value: '' } });
            dispatch({ type: types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA, payload: { path: 'passwordnuevo', value: '' } });
            dispatch({ type: types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA, payload: { path: 'verificacion', value: '' } });

			displayMessages(dispatch, err)
		})
    }
}


// WEBPACK FOOTER //
// ./src/actions/cambiarcontrasena.js